/**
 * Utilitários para o número do cartão (UID NFC).
 *
 * Formato canônico: hexadecimal maiúsculo, sem separadores (ex.: "DC112A9A").
 */

/**
 * Converte o valor decimal lido pelo leitor de cadastro (que interpreta o UID como um
 * uint de 32 bits little-endian) de volta para a sequência de bytes original em hexadecimal.
 *
 * Ex.: 2586448348 -> "DC112A9A"
 *
 * @param {number|string} decimal valor decimal do UID
 * @returns {string} UID em hexadecimal maiúsculo, sem separadores
 */
export function decimalToHexUid(decimal) {
  let value = Number(decimal)

  if (!Number.isFinite(value) || value < 0) {
    value = 0
  }

  value %= 4294967296 // limita a um uint de 32 bits (2^32)

  const bytes = [
    value % 256,
    Math.floor(value / 256) % 256,
    Math.floor(value / 65536) % 256,
    Math.floor(value / 16777216) % 256,
  ]

  return bytes.map(b => b.toString(16).padStart(2, '0')).join('').toUpperCase()
}

/**
 * Normaliza uma entrada para o formato canônico.
 * - Remove separadores (":", "-", espaço) e aplica maiúsculas.
 * - Se for um decimal comprido demais para um UID de 4 bytes em hexadecimal (mais de 8 dígitos),
 *   converte de decimal para hexadecimal.
 *
 * @param {number|string} raw
 * @returns {string}
 */
export function normalizeCardNumber(raw) {
  if (raw === null || raw === undefined) return ''

  const cleaned = String(raw)
    .trim()
    .replace(/[:\-\s]/g, '')
    .toUpperCase()

  if (cleaned.length > 8 && /^\d+$/.test(cleaned)) {
    return decimalToHexUid(Number(cleaned))
  }

  return cleaned
}
